<div class="novo-relato-container">
  <div *ngIf="!sucessoRelato">
    <div class="form-content">
      <label for="descricaoRelato" class="descricao-relato"
        >DESCREVA O SEU RELATO</label
      >
      <textarea
        id="descricaoRelato"
        [(ngModel)]="descricaoRelato"
        placeholder="Descreva o seu relato..."
        class="form-control"
      ></textarea>

      <div class="nome-relato">
        <input
          type="text"
          [(ngModel)]="nomeRelato"
          placeholder="Gostaria de dar um nome para seu relato?"
          class="form-control"
        />
      </div>

      <div class="contatos-email">
        <input type="checkbox" [(ngModel)]="enviarEmail" />
        <span>Enviar informações por e-mail</span>
      </div>

      <div class="dropdown-multiselect">
        <div
          class="dropdown-header"
          [class.disabled]="!enviarEmail"
          (click)="toggleDropdown()"
        >
          <ng-container *ngIf="selectedResponsaveis.length === 0">
            <span class="placeholder">Selecione os contatos</span>
          </ng-container>
          <ng-container *ngIf="selectedResponsaveis.length > 0">
            <span class="selected-list">
              {{
                selectedResponsaveis.length === responsavel.length
                  ? "Todos os contatos selecionados"
                  : selectedResponsaveis.length + " contato(s) selecionado(s)"
              }}
            </span>
          </ng-container>
          <span class="arrow" [class.open]="dropdownOpen">&#9662;</span>
        </div>
        <div
          *ngIf="dropdownOpen && enviarEmail"
          class="dropdown-list"
          (click)="$event.stopPropagation()"
        >
          <label class="select-all">
            <input
              type="checkbox"
              [checked]="isAllSelected()"
              (change)="toggleSelectAll($event)"
            />
            Selecionar todos
          </label>
          <div class="divider"></div>
          <label *ngFor="let responsavel of responsavel; let i = index">
            <input
              type="checkbox"
              [checked]="isSelected(responsavel)"
              (change)="toggleSelection(responsavel)"
            />
            {{ responsavel.name }}
          </label>
        </div>
      </div>
    </div>

    <div class="footer-actions">
      <button class="btn btn-secondary" (click)="clear()" type="button">
        LIMPAR DADOS
      </button>
      <button class="btn btn-primary" (click)="criarRelato()" type="button">
        CRIAR RELATO
      </button>
    </div>
  </div>

  <div *ngIf="sucessoRelato" class="form-content sucesso-content">
    <div class="sucesso-icon-text">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/concluido.png"
        alt=""
      />
      <span class="sucesso-msg">Relato criado com sucesso!</span>
    </div>
    <div class="footer-actions-continuar">
      <button class="btn btn-primary" type="button" (click)="continuar()">
        CONTINUAR
      </button>
    </div>
  </div>
</div>
